import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./HotelDetailMain.css";
import { Container, Row, Col } from "react-bootstrap";
import { CiLocationOn } from "react-icons/ci";
import Carousel from "react-bootstrap/Carousel";
import { FaUserFriends } from "react-icons/fa";
import { FaWifi } from "react-icons/fa";
import { Ri24HoursFill } from "react-icons/ri";
import { FaPumpSoap } from "react-icons/fa6";
import { IoRestaurant } from "react-icons/io5";
import { CgGym } from "react-icons/cg";
import HotelRoomsOverView from "./HotelRoomsOverView";
import HotelImagesGallery from "./HotelImagesGallery";
import FlightListSkeleton from "../../Flight/FlightList/FlightListSkeleton";
import HotelDetailSkeleton from "./HotelDetailSkeleton";

const HotelDetailMain = () => {
  const getGuestRoomDisplay = (paxString) => {
    if (!paxString) return "";

    const rooms = paxString.split("?");
    const totalRooms = rooms.length;

    let totalGuests = 0;

    rooms.forEach((room) => {
      const [adults, children] = room.split("_").map(Number);
      totalGuests += adults + children;
    });

    return `${totalGuests} Guest${
      totalGuests > 1 ? "s" : ""
    } | ${totalRooms} Room${totalRooms > 1 ? "s" : ""}`;
  };

  const [showGallary, setShowGallery] = useState(false);
  const [hotelDetails, setHotelDetails] = useState("");
  const [hotelData, setHotelData] = useState(null);
  const navigate = useNavigate();

  const handleOpenGallery = () => {
    setShowGallery(true);
  };
  //  const storedData = localStorage.getItem('hotelId');
  // const storedRoom = JSON.parse(localStorage.getItem("rooms"));
  useEffect(() => {
    const storeBatchKey = localStorage.getItem("batchKey");
    const storedData = localStorage.getItem("hotelId");
    const storedRoom = JSON.parse(localStorage.getItem("rooms"));

    const requestData = {
      hid: storedData,
      // BatchKey: storeBatchKey,
      // Rooms: storedRoom,
    };

    // console.log("requestData",requestData)

    const fetchHotelDetails = async () => {
      const response = await axios.post(
        "https://admin.travelsdata.com/api/Hotel/HotelDetail",
        requestData
      );
      setHotelData(response.data.data);
      // setHotelDetails(response.data.data.rooms);
      console.log("response data", response.data.data);
    };
    fetchHotelDetails();
  }, []);

  return (
    <div className="hotelmodifysearch-Main">
      {hotelData && hotelData.rooms && hotelData.rooms.length > 0 ? (
        <div style={{ position: "relative" }}>
          <Container>
            <div className="hotel-detailMain">
              <div className="hotel-detailSubMain">
                <div className="hotel-detailHeading">
                  <div>
                    <div className="hotelListingstyling-name hotelListingstylingDetail-name">
                      {hotelData.HotelDetail.name}

                      <div
                        className="rating-score"
                        style={{ textAlign: "center", fontSize: "18px" }}
                      >
                        {[...Array(5)].map((_, index) => (
                          <span
                            key={index}
                            style={{
                              color:
                                index <
                                Number(hotelData.HotelDetail.star_rating)
                                  ? "#FFD700"
                                  : "#ccc",
                            }}
                          >
                            ★
                          </span>
                        ))}
                      </div>
                    </div>

                    <div className="hotel-Address">
                      <CiLocationOn />{" "}
                      <span>{hotelData.HotelDetail.address}</span>
                    </div>
                  </div>
                  <div className="hotel-numberic-rating hotelDetail-ratings">
                    <div>
                      <div className="rating-label">Excellent</div>
                      <div className="rating-reviews">1134 reviews</div>
                    </div>
                    <div className="rating-score rating-score-inNum">
                      {hotelData.HotelDetail.star_rating}
                    </div>
                  </div>
                </div>
                <div className="hotelSilder_totalFare">
                  <div className="hotel-ColbigSilder">
                    <div className="hotel-bigSilder">
                      {hotelData.HotelDetail.images &&
                      hotelData.HotelDetail.images.length > 0 ? (
                        <Carousel>
                          {hotelData.HotelDetail.images.slice(0, 3).map(
                            (img, index) =>
                              img && (
                                <Carousel.Item key={index}>
                                  <img
                                    className="d-block w-100"
                                    src={img}
                                    alt={`Slide ${index + 1}`}
                                  />
                                </Carousel.Item>
                              )
                          )}
                        </Carousel>
                      ) : (
                        <p>No main images available.</p>
                      )}
                    </div>

                    <div className="carousel-belowImag">
                      {[3, 4].map((index) =>
                        hotelData.HotelDetail.images &&
                        hotelData.HotelDetail.images[index] ? (
                          <div key={index}>
                            <img
                              src={hotelData.HotelDetail.images[index]}
                              alt={`Thumbnail ${index + 1}`}
                              className="carousel-smallImages"
                            />
                          </div>
                        ) : null
                      )}

                      {hotelData.HotelDetail.images &&
                        hotelData.HotelDetail.images[5] && (
                          <div
                            className="carouselImage-container"
                            onClick={handleOpenGallery}
                            style={{ cursor: "pointer" }}
                          >
                            <img
                              src={hotelData.HotelDetail.images[5]}
                              alt="More Images"
                              className="carousel-smallImages"
                            />
                            <div className="carouselImageOverlay-full">
                              <div className="carouselImageOverlay-text">
                                +15
                              </div>
                            </div>
                          </div>
                        )}
                    </div>
                  </div>

                  <div className="hotel-ColtotalFare">
                    <div className="hotel-totalFare">
                      <div style={{ display: "block" }}>
                        <div className="hoteRoom-Usage">
                          Day Use Room 6Hrs (Check In 9am - Check Out 3pm) (6
                          Hours stay between 09:00 to 15:00)
                        </div>

                        <div className="hotel-Guests_Room">
                          {getGuestRoomDisplay(hotelData.pax)}
                        </div>
                      </div>
                      <div className="hoteRoom-UsageCharges">
                        <div className="cross-pricing">
                          {" "}
                          ₹ {Math.round(hotelData.rooms[0].TotalFare * 1.1)}
                        </div>
                        <div className="real-pricing">
                          ₹ {Math.round(hotelData.rooms[0].TotalFare)}
                        </div>
                        <div className="hotel-taxesFees">
                          + ₹ {Math.round(hotelData.rooms[0].TotalTax)} Taxes &
                          fees
                        </div>
                        <div
                          className="hotel-taxesFees"
                          style={{ color: "#737373" }}
                        >
                          Base price (Per Night)
                        </div>
                      </div>
                    </div>

                    <div
                      className="hotel-amenities"
                      style={{ flexWrap: "wrap" }}
                    >
                      <div className="free_amenities">
                        <FaUserFriends className="free_amenitiesIcons" />
                        Couple Friendly
                      </div>
                      <div className="free_amenities">
                        <FaWifi className="free_amenitiesIcons" />
                        Free Wifi
                      </div>
                      <div className="free_amenities">
                        <Ri24HoursFill className="free_amenitiesIcons" />
                        24-hour Room Service
                      </div>
                      <div className="free_amenities">
                        <FaPumpSoap className="free_amenitiesIcons" />
                        Free toiletries
                      </div>
                      <div className="free_amenities">
                        <IoRestaurant className="free_amenitiesIcons" />
                        Restaurant
                      </div>
                      <div className="free_amenities">
                        <CgGym className="free_amenitiesIcons" />
                        Gym
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Container>
          <HotelImagesGallery
            setShowGallery={setShowGallery}
            showGallary={showGallary}
            hotelData={hotelData.HotelDetail}
          />
          <HotelRoomsOverView hotelData={hotelData} />
        </div>
      ) : (
        <HotelDetailSkeleton />
      )}
    </div>
  );
};

export default HotelDetailMain;
